import { observable, runInAction } from 'mobx';
import { IStyleCategoryServices, StyleCategory } from 'services/styleCategory_services';

export type StyleCategoryStore = {
  styleCategory: {
    data: Array<StyleCategory>;
    message: string;
    isSuccess: boolean;
    recordsTotal: number;
    resultsCount: number;
    pagesCount: number;
  };
};
export interface IStyleCategoryPresenter {
  createStore(): StyleCategoryStore;
  getListStyleCategory(store: StyleCategoryStore, data: object): Promise<void>;
}

export function createStyleCategoryPresenter({
  styleCategoryServices,
}: {
  styleCategoryServices: IStyleCategoryServices;
}): IStyleCategoryPresenter {
  return {
    createStore: (): StyleCategoryStore =>
      observable({
        styleCategory: {
          data: [],
          message: '',
          isSuccess: false,
          recordsTotal: 0,
          resultsCount: 0,
          pagesCount: 0,
        }
      }),
    getListStyleCategory: async (store, data) => {
      try {
        const styleCategorys = await styleCategoryServices.getList(data);

        runInAction(() => {
          store.styleCategory.data = styleCategorys.data;
          store.styleCategory.pagesCount = styleCategorys.pagesCount;
          store.styleCategory.resultsCount = styleCategorys.resultsCount;
          store.styleCategory.recordsTotal = styleCategorys.recordsTotal;
          store.styleCategory.isSuccess = styleCategorys.isSuccess;
          store.styleCategory.message = styleCategorys.message;
        });
      } catch (error) {
        console.log(error);
      }
    },


  };
}
